import { useState, useContext, useCallback } from 'react';
import { BasicData } from '@App';

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DayPickerRangeController } from 'react-dates';
import moment from "moment";
import { Trans } from '@lingui/macro';
import { useDispatch } from 'react-redux';
import { setEnquiryValue } from '@utils/redux/slices/enquiry';

import './style.scss';

const DateInputs = ({ details, disabled = false }) => {
    const dispatch = useDispatch();
    const { language } = useContext(BasicData);
    moment.locale(language);

    const [focusedInput, setFocusedInput] = useState('');
    const [showCalendar, setShowCalendar] = useState(false);

    const clearStartDate = useCallback(() => {
        dispatch(setEnquiryValue({
            ...details,
            arrival_date: ""
        }))
    }, [dispatch, details])

    const clearEndDate = useCallback(() => {
        dispatch(setEnquiryValue({
            ...details,
            departure_date: ""
        }))
    }, [dispatch, details])

    const showCalendarHandler = (inpt) => {
        setShowCalendar(true);
        setFocusedInput(inpt);
    }

    const handleDatesChange = useCallback(dates => {
        const startDateString = dates.startDate ? dates.startDate.format("DD MMMM YYYY") : '';
        const endDateString = dates.endDate ? dates.endDate.format("DD MMMM YYYY") : '';

        dispatch(setEnquiryValue({
            ...details,
            arrival_date: startDateString,
            departure_date: endDateString
        }))

        if (focusedInput === 'endDate') {
            setTimeout(() => {
                setShowCalendar(false);
            }, 50)
        }
    }, [dispatch, details, focusedInput])

    return (
        <>
            <div className={`input-group ${details?.arrival_date?.length || focusedInput === "startDate" ? 'active' : ''} ${disabled ? 'disabled' : ''}`}>
                <h6 htmlFor="txt-arrival-date"><Trans>Arrival Date</Trans></h6>

                <div className="date">
                    <div tabIndex={0} className='calendar-input' onClick={() => showCalendarHandler('startDate')}>
                        {details?.arrival_date}
                    </div>
                    {details?.arrival_date?.length > 0 &&
                        <i className="icon icon-x" onClick={clearStartDate}></i>
                    }
                </div>

            </div>
            <div className={`input-group ${details?.departure_date?.length || focusedInput === "endDate" ? 'active' : ''} ${disabled ? 'disabled' : ''}`}>
                <h6 htmlFor="txt-departure-date"><Trans>Departure Date</Trans></h6>

                <div className="date">
                    <div tabIndex={1} className='calendar-input' onClick={() => showCalendarHandler('endDate')}>
                        {details?.departure_date}
                    </div>
                    {details?.departure_date?.length > 0 &&
                        <i className="icon icon-x" onClick={clearEndDate}></i>
                    }
                </div>
            </div>

            {showCalendar &&
                <DayPickerRangeController
                    startDate={details?.arrival_date?.length ? moment(details.arrival_date) : null}
                    endDate={details?.departure_date?.length ? moment(details.departure_date) : null}
                    onDatesChange={handleDatesChange}
                    focusedInput={focusedInput}
                    onFocusChange={setFocusedInput}
                    numberOfMonths={1}
                    hideKeyboardShortcutsPanel
                    enableOutsideDays
                    isOutsideRange={(day) => day.isBefore(moment())}
                    onOutsideClick={() => { setShowCalendar(false) }}
                    renderMonthElement={({ month, onMonthSelect, onYearSelect }) => (
                        <div className='date-select-wrapper'>
                            <div>
                                <select
                                    value={month.month()}
                                    onChange={(e) => onMonthSelect(month, e.target.value)}
                                >
                                    {moment.months().map((label, value) => (
                                        <option key={value} value={value}>{label}</option>
                                    ))}
                                </select>
                            </div>
                            <div>
                                <select value={month.year()} onChange={(e) => onYearSelect(month, e.target.value)}>
                                    <option value={moment().year()}>{moment().year()}</option>
                                    <option value={moment().year() + 1}>{moment().year() + 1}</option>
                                    <option value={moment().year() + 2}>{moment().year() + 2}</option>
                                    <option value={moment().year() + 3}>{moment().year() + 3}</option>
                                    <option value={moment().year() + 4}>{moment().year() + 4}</option>
                                    <option value={moment().year() + 5}>{moment().year() + 5}</option>
                                </select>
                            </div>
                        </div>
                    )}
                />
            }
        </>
    )
}

export default DateInputs;